export default {
  title: '我的统计',
  menu: '统计',
  label: {
    referrals: '推荐',
    jobShares: '已分享的职位',
    pageViews: '浏览次数',
    referJobs: '推荐职位',
    referRules: '推荐规则/政策',
    referFAQ: '推荐FAQ',
    referJobsText: '分享职位到你的圈子',
    myDashboard: '统计',
    views: '浏览次数',
    leads: '潜在候选人',
    resumeSubmit: '已提交简历',
    recommendPositions: '推荐职位',
    positionTip: '分享职位到你的圈子',
    recommendRules: '推荐规则/政策',
    recommendFAQ: '推荐FAQ'
  },
  potentialStatus: {
    leads: '潜在候选人',
    prospects: '潜在候选人（已注册）',
    submitReferrals: '已提交简历'
  }
}
